import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
// import Auth from './views/Auth.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      meta: { checkAuth: false },
      component: Home
    },
    {
      path: '/index',
      name: 'index',
      component: () =>
        import(/* webpackChunkName: "auth" */ './views/Index.vue'),
      meta: { checkAuth: true }
    },
    {
      path: '/appointment/apply',
      name: 'appointment-apply',
      component: () =>
        import(/* webpackChunkName: "appointment" */ './views/appointment/Apply.vue'),
      meta: { checkAuth: true }
    },
    {
      path: '/appointment/info',
      name: 'appointment-info',
      component: () =>
        import(/* webpackChunkName: "appointment" */ './views/appointment/ApplyInfo.vue'),
      meta: { checkAuth: true }
    },
    {
      path: '/appointment/list',
      name: 'appointment-list',
      component: () =>
        import(/* webpackChunkName: "appointment" */ './views/appointment/UserList.vue'),
      meta: { checkAuth: true }
    },
    {
      path: '/appointment/confirm_list',

      name: 'appointment-confirm',
      component: () =>
        import(/* webpackChunkName: "appointment" */ './views/appointment/ConfirmList.vue'),
      meta: { checkAuth: true }
    },
    {
      path: '/appointment/confirm_info',
      name: 'appointment-confirm-info',
      meta: { checkAuth: true },

      component: () =>
        import(/* webpackChunkName: "appointment" */ './views/appointment/ConfirmInfo.vue'),
      meta: { checkAuth: true }
    },
    {
      path: '/appointment/success',
      name: 'appointment-success',
      meta: { checkAuth: true },

      component: () =>
        import(/* webpackChunkName: "appointment" */ './views/appointment/Success.vue')
    },
    {
      path: '/appointment/faile',
      name: 'appointment-faile',
      // meta: { checkAuth: true },

      component: () =>
        import(/* webpackChunkName: "appointment" */ './views/appointment/Faile.vue')
    },
    {
      path: '/employee/bind',
      name: 'employee-bind',
      meta: { checkAuth: true },

      component: () =>
        import(/* webpackChunkName: "employee" */ './views/employee/bind.vue')
    },
    {
      path: '/employee/manage',
      name: 'employee-manage',
      meta: { checkAuth: true },

      component: () =>
        import(/* webpackChunkName: "employee" */ './views/employee/manage.vue')
    }
,
    {
      path: '/xf/index',
      name: 'xf-index',
      meta: { checkAuth: true },

      component: () =>
        import(/* webpackChunkName: "employee" */ './views/xf/index.vue')
    }
  ]
})
